import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { versionActions } from '../../behavior/version/index';

const VersionComponent = ({ getVersion, version, axiosConfig, api }) => {
	useEffect(() => {
		if(api){
			getVersion({api});
		} else {
			getVersion({axiosConfig});
		}
	}, []);
	return (
		<span className="version-sw" id="version-sw">
			{version ? `v.${version}` : null}
		</span>
	);
};

const mapStateToProps = state => ({
	version: state.version.version
});

const mapDispatchToProps = dispatch => ({
	getVersion: ({api, axiosConfig}) => dispatch(versionActions.getVersion({axiosConfig, api}))
});

export default connect(mapStateToProps, mapDispatchToProps)(VersionComponent);
